/**
 * 德育评价类型 API
 */
import { request } from './request'

/**
 * 创建评价类型
 * @param {object} data - 类型数据
 */
export function createEvaluationType(data) {
  return request('/api/evaluation_type', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * 获取指定评价类型
 * @param {number|string} typeId - 类型 ID
 */
export function getEvaluationType(typeId) {
  return request(`/api/evaluation_type/${typeId}`)
}

/**
 * 获取所有评价类型
 */
export function getEvaluationTypes() {
  return request('/api/evaluation_type')
}

/**
 * 获取评价类型及其关联项目
 */
export function getEvaluationTypesWithProjects() {
  return request('/api/evaluation_type/with-projects')
}

/**
 * 更新评价类型
 * @param {number|string} typeId - 类型 ID
 * @param {object} data - 更新数据
 */
export function updateEvaluationType(typeId, data) {
  return request(`/api/evaluation_type/${typeId}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

/**
 * 删除评价类型
 * @param {number|string} typeId - 类型 ID
 */
export function deleteEvaluationType(typeId) {
  return request(`/api/evaluation_type/${typeId}`, {
    method: 'DELETE'
  })
}
